export const formatDecimal = (value: string | number | undefined, countryCode: string) => {
    if (value === undefined) return value;

    const strValue = value.toString();

    switch (countryCode) {
        case 'NO':
            return strValue.replace('.', ',');
        default:
            return strValue;
    }
};
